import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { DocumentTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-documenttype-container',
  templateUrl: './documenttype-container.component.html',
  styleUrls: ['./documenttype-container.component.scss']
})
export class DocumentTypeContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  documenttypes$: Observable<DocumentTypeDto[]>;
  loading: boolean;
  isLoadingDocumentType$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingDocumentType$ = this.gatwayFacade.isLoadingGateway("DocumentType");
    this.documenttypes$ = this.gatwayFacade.loadGateway("DocumentType");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteDocumentType(deletedValue: any) {
    this.gatwayFacade.remove("DocumentType", deletedValue);
  }


// this method control both the create and update

  onSubmitDocumentType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.DocumentTypes;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllDocumentType = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllDocumentType.push(pullData[i]);
    }
  }

// check if the addAllDocumentType array is not empty, then dispatch the data to the store
   if(addAllDocumentType.length > 0) {
    this.gatwayFacade.add('DocumentType', addAllDocumentType);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('DocumentType', allUpdates, ['id']);
  }

   }


}
